/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Check = props => (
  <svg
    viewBox="0 0 10 8"
    width={props.size ? props.size.width : '21px'}
    height={props.size ? props.size.height : '10px'}
    {...props}
  >
    <g
      id="Dark-version"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="06-Event-Setup-B-(Sequential)"
        transform="translate(-467.000000, -462.000000)"
        fill={props.color || '#202125'}
      >
        <g id="Table" transform="translate(-20.000000, 352.000000)">
          <g id="Row-2" transform="translate(82.000000, 88.000000)">
            <g id="Checkbox-1" transform="translate(402.000000, 17.000000)">
              <path
                d="M6.19061721,12.5018249 L3.12773473,9.35419495 C2.95708842,9.18101543 2.95708842,8.89913812 3.12773473,8.72411627 L3.74643699,8.09403759 C3.9170833,7.92085807 4.19449294,7.92085807 4.36513925,8.09403759 L6.5004059,10.299313 L11.2601253,5.39409517 C11.4307716,5.22091565 11.7081812,5.22091565 11.8788275,5.39409517 L12.4975298,6.02417385 C12.6681761,6.19735337 12.6681761,6.48015184 12.4975298,6.65333136 L6.80931947,12.5036672 C6.63867316,12.6759255 6.36213863,12.6759255 6.19061721,12.5018249 L6.19061721,12.5018249 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Check;
